const topicCardFlip = require('./../sounds/topic-card-flip.wav');
const neutralBtn = require('./../sounds/neutral.wav');
const carouselTransfer = require('./../sounds/nugget-carousel-trans.wav');
const globalAlert = require('./../sounds/alert.wav');
const mainUiFlip = require('./../sounds/main-ui-flip.wav');
const negative = require('./../sounds/negative.wav');
const positive = require('./../sounds/positive.wav');
const topicToNugget = require('./../sounds/topic-to-nugget.wav');

// List of sounds for properties select
const sounds = [
  { text: 'No sound', value: '' },
  { text: 'Topic Card Flip', value: topicCardFlip },
  { text: 'Neutral Button', value: neutralBtn },
  { text: 'Carousel Transfer', value: carouselTransfer },
  { text: 'Global Alert', value: globalAlert },
  { text: 'Main UI Flip', value: mainUiFlip },
  { text: 'Negative (wrong answer)', value: negative },
  { text: 'Positive (right answer)', value: positive },
  { text: 'Topic to Nugget', value: topicToNugget },
];

export default {
  data() {
    return {
      allSounds: null,
    };
  },
  mounted() {
    this.initializeSounds();
  },
  created() {},
  methods: {
    initializeSounds() {
      // Populate all sounds
      this.allSounds = sounds;
    },
    getAllSounds() {
      // return allSounds via mixin
      return this.allSounds;
    },
  },
};
